import { useRef, useState } from "react";
import { IoChevronDown, IoClose } from "react-icons/io5";
import { Field, FieldAnswer, Patient, Reference } from "../data/allTypes";
import { getItemId, jsonAbstract, shouldOpenInDrawer, uid } from "../utils/utils";
import { IconButton } from "./buttons";
import SearchKeyHighliter from "./seachkeyHighlighter";
import { Input } from "./universalInput";
import { AiDescription } from "../app/aiTasks/aiDescription";

export function ReferenceTile({
  patient,
  reference,
  searchKey,
  fieldAnswers,
  isInitalyExpanded,
  isInitiallyActive,
  additionalClass,
  onActiveChange,
  onExpansionChange,
  onChange,
  children,
}: {
  patient: Patient | null | undefined;
  reference: Reference | null;
  searchKey?: string;
  fieldAnswers?: (FieldAnswer | null | undefined)[] | null | undefined;
  isInitiallyActive?: boolean | null | undefined;
  isInitalyExpanded?: boolean | null | undefined;
  additionalClass?: string | null | undefined;
  onActiveChange?: (newValue: boolean) => void;
  onExpansionChange?: (newValue: boolean) => void;
  onChange?: (field: Field, newValue: any) => void;

  children?: any;
}) {
  const ref = useRef<HTMLDivElement>(null);
  let [isExpanded, setIsExpanded] = useState(isInitalyExpanded || false);
  let [isActive, setIsActive] = useState(isInitiallyActive || false);

  if (!reference) return null;

  return (
    <AiDescription
      item={{
        title: reference.name || "",
        type: "card",
        id: reference.id,
        description: `A card for ${reference.name} when clicking once it activates, when clicking a second time after activation it expands and allows to add more details using inputs inside of it. When clicking on the close button it closes the card and deactivates it.`,
        value: `isExpanded : ${isExpanded} isActive : ${isActive}`,
        ref,
      }}
    >
      <div
        ref={ref}
        onClick={async () => {
          if (!isActive) {
            await onActiveChange?.(true);
            return setIsActive(!isActive);
          }

          if (shouldOpenInDrawer(reference))
            return onExpansionChange?.(isExpanded);

          setIsExpanded(!isExpanded);
          onExpansionChange?.(!isExpanded);
        }}
        className={`reference expansionTile ${additionalClass || ""} ${
          isExpanded ? "expanded" : ""
        }
  
        ${isActive ? "active" : ""}
        
        `}
      >
        <div className="expansionTileHeader">
          {isActive ? (
            <IconButton
              onClick={async (e) => {
                e.stopPropagation();
                setIsActive(false);
                await onActiveChange?.(false);
                await onExpansionChange?.(false);
                setIsExpanded(false);
              }}
            >
              <IoClose size={18} />
            </IconButton>
          ) : (
            <div></div>
          )}
          <div className="reference-title capitalize">
            {isActive ? (
              reference.name || ""
            ) : (
              <SearchKeyHighliter searchKey={searchKey || ""}>
                {reference.name || ""}
              </SearchKeyHighliter>
            )}
          </div>

          {isActive ? (
            <div className="center">
              <IoChevronDown size={18} />
            </div>
          ) : (
            <div className="gray usageCount " style={{ textAlign: "right" }}>
              {reference.usageCount || reference.cim10Code}
            </div>
          )}
        </div>
        {isExpanded && (
          <div className="expansionTileContent" key={uid()}>
            <div className="grid c1 gap10">
              {reference.sections?.map((section, index, allSections) => {
                if (!section) return;
                return (
                  <div key={section.id} className="c1 gap10">
                    {allSections.length > 1 ? (
                      <div className="bold f15">{section.name}</div>
                    ) : null}
                    {section.fields?.map((field, index) => {
                      if (!field) return;
                      let fieldAnswer = fieldAnswers?.find(
                        (fieldAnswer) => fieldAnswer?.field?.id == field.id
                      );

                      return (
                        <Input
                          key={`field-${field.id}`}
                          isHorizontal={true}
                          name={field.name}
                          unitName={field?.unit?.name}
                          value={getItemId(fieldAnswer?.value)}
                          type={jsonAbstract(field.type)}
                          additionalUploadData={
                            ["upload", "uploads"].includes(field.type || "none")
                              ? {
                                  patient: getItemId(patient),
                                  field: field?.id,
                                }
                              : {}
                          }
                          options={field?.options
                            ?.filter((a) => a)
                            .map((option) => {
                              return { value: option!.id, label: option!.name };
                            })}
                          placeholder={field.placeholder}
                          onChange={(newValue) => {
                            console.log("the new dedefef value", newValue);
                            
                            onChange?.(field, newValue);
                          }}
                        ></Input>
                      );
                    })}
                  </div>
                );
              })}

              {children}
            </div>
          </div>
        )}
      </div>
    </AiDescription>
  );
}
